export default {
  name: "AsideMenu",
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};